import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Container } from 'react-bootstrap';
import {
  fetchOutrightsAllEvents,
  selectFilteredEvents,
  selectAvailableSports,
  selectOutrightsLoading,
  selectOutrightsError,
  selectSelectedSportId,
  setSelectedSportId,
  clearOutrightsError
} from 'stores/outrights';
import TournamentCard from './partials/TournamentCard';
import SportChips from './partials/SportChips';
import { OUTRIGHT_ACCENT } from './theme';

function Outrights() {
  const { t } = useTranslation('translations', { useSuspense: false });
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const events = useSelector(selectFilteredEvents);
  const sports = useSelector(selectAvailableSports);
  const loading = useSelector(selectOutrightsLoading);
  const error = useSelector(selectOutrightsError);
  const selectedSportId = useSelector(selectSelectedSportId);

  useEffect(() => {
    window.scrollTo(0, 0);
    dispatch(fetchOutrightsAllEvents());
  }, [dispatch]);

  const onRetry = () => {
    dispatch(clearOutrightsError());
    dispatch(fetchOutrightsAllEvents());
  };

  return (
    <Container fluid className="g-0">
      <SportChips
        sports={sports}
        selectedSportId={selectedSportId}
        onSelect={(id) => dispatch(setSelectedSportId(id))}
        onBack={() => navigate(-1)}
      />

      <div className="px-3 py-3">
        {loading && (
          <div className="text-center py-3" style={{ color: 'var(--bs-body-color)' }}>
            {t('outrights.loading')}
          </div>
        )}

        {!loading && error && (
          <div
            className="rounded p-3 text-center"
            style={{
              background: 'var(--bs-body-bg)',
              border: '1px solid var(--bs-border-color)'
            }}
          >
            <div className="mb-2" style={{ color: 'var(--bs-body-color)' }}>{error}</div>
            <button
              type="button"
              className="btn btn-sm"
              onClick={onRetry}
              style={{ background: OUTRIGHT_ACCENT, color: '#fff', border: 'none', fontWeight: 600 }}
            >
              {t('outrights.retry')}
            </button>
          </div>
        )}

        {!loading && !error && events.length === 0 && (
          <div
            className="text-center py-4"
            style={{ opacity: 0.65, color: 'var(--bs-body-color)' }}
          >
            {t('outrights.noEvents')}
          </div>
        )}

        {!loading && !error &&
          events.map((event) => (
            <TournamentCard key={event.se.id} event={event} />
          ))}
      </div>
    </Container>
  );
}

export default Outrights;
